// extracted by mini-css-extract-plugin
module.exports = {"clickable":"styles_clickable__2I8ej","large":"styles_large__2jyqE"};